import styled, { css } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

import { PAGE_SIZE } from './PageCard.style';

export const ScrollableCarouselWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: auto;
  z-index: ${({ theme }) => theme.ZIndex.ZIndex.Elevated};
`;

export const StyledAddButtonWrapper = styled.div`
  button {
    width: ${utils.rem(PAGE_SIZE)};
    height: ${utils.rem(PAGE_SIZE)};
  }
`;

export const StyledCarouselWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: ${({ theme }) => utils.rem(theme.Components.ToolBar.wrapperSize)};
  min-width: 100%;
  width: 100vw;
  max-width: 100%;
  height: auto;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
`;

export const StyledPageNumberContainer = styled.div`
  position: absolute;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;

  ${({ theme }) => css`
    background: ${theme.Color.NeutralsFixed.Gray};
    bottom: ${utils.rem(theme.Spacing.Size.XXSmall)};
    left: ${utils.rem(theme.Spacing.Size.XXSmall)};
    height: ${utils.rem(theme.Icon.Size.XSmall)};
    width: ${utils.rem(theme.Icon.Size.XSmall)};
    border-radius: ${utils.rem(theme.Border.Radius.XSmall)};
  `}
`;
